module.exports = __webpack_public_path__ + "static/media/medical_van.9f402165.webp";